export enum DYNAMO_DB_TABLES {
  affiliateObjects = 'prod_AffiliateObjects',
  objectTemplates = 'prod_ObjectTemplates',
}
